import { render, staticRenderFns } from "./ChatCsatPopup.vue?vue&type=template&id=3b53da84&scoped=true"
import script from "./ChatCsatPopup.vue?vue&type=script&lang=js"
export * from "./ChatCsatPopup.vue?vue&type=script&lang=js"
import style0 from "./ChatCsatPopup.vue?vue&type=style&index=0&id=3b53da84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b53da84",
  null
  
)

export default component.exports